function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-dcc4c971-796c-4413-8ce9-e23d77e1ebcb",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.18 79.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "uuid-d0f15b72-e12a-494e-8995-cf6e997726ec",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f2836",
      strokeWidth: 0
    },
    d: "M133.43,78.95h-3.91l-15.74-23.86v23.86h-3.91v-30.01h3.91l15.74,23.82v-23.82h3.91v30.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f2836",
      strokeWidth: 0
    },
    d: "M156.71,63.96c-1.71,1.65-4.31,2.47-7.8,2.47h-5.76v12.51h-3.91v-29.97h9.67c3.38,0,5.96.82,7.72,2.45s2.64,3.74,2.64,6.32-.85,4.56-2.56,6.21ZM153.72,61.79c1.03-.95,1.55-2.29,1.55-4.04,0-3.7-2.12-5.55-6.36-5.55h-5.76v11.01h5.76c2.18,0,3.78-.47,4.82-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f2836",
      strokeWidth: 0
    },
    d: "M185.97,57.66c-.83-1.75-2.04-3.1-3.61-4.06-1.58-.96-3.41-1.44-5.5-1.44s-3.98.48-5.65,1.44-3,2.34-3.96,4.13c-.96,1.79-1.44,3.86-1.44,6.21s.48,4.41,1.44,6.19c.96,1.78,2.28,3.15,3.96,4.11,1.68.96,3.56,1.44,5.65,1.44,2.92,0,5.33-.87,7.22-2.62,1.89-1.75,3-4.11,3.31-7.09h-11.95v-3.18h16.12v3.01c-.23,2.47-1,4.72-2.32,6.77s-3.05,3.67-5.2,4.86c-2.15,1.19-4.54,1.78-7.18,1.78-2.78,0-5.32-.65-7.61-1.96-2.29-1.3-4.11-3.12-5.44-5.44-1.33-2.32-2-4.94-2-7.87s.67-5.55,2-7.89c1.33-2.34,3.15-4.16,5.44-5.46,2.29-1.3,4.83-1.96,7.61-1.96,3.18,0,6,.79,8.45,2.37,2.45,1.58,4.23,3.8,5.35,6.66h-4.69Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f2836",
      strokeWidth: 0
    },
    d: "M115.82,20.31v11.13h-5.99V1.44h10.92c3.54,0,6.21.85,8.01,2.55,1.8,1.7,2.7,4.01,2.7,6.93s-.93,5.14-2.78,6.84c-1.86,1.7-4.5,2.55-7.93,2.55h-4.93ZM125.39,10.92c0-1.5-.41-2.65-1.23-3.44-.82-.79-2.17-1.19-4.04-1.19h-4.29v9.22h4.29c3.51,0,5.27-1.53,5.27-4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f2836",
      strokeWidth: 0
    },
    d: "M148.18,9.01c1.42.93,2.42,2.2,3.02,3.78v-4.89h5.95v23.54h-5.95v-4.93c-.6,1.59-1.6,2.85-3.02,3.8-1.42.95-3.12,1.42-5.1,1.42s-3.77-.48-5.35-1.45c-1.59-.96-2.83-2.36-3.72-4.19-.89-1.83-1.34-3.97-1.34-6.44s.45-4.61,1.34-6.44c.89-1.83,2.13-3.22,3.72-4.19,1.59-.96,3.37-1.45,5.35-1.45s3.68.47,5.1,1.4ZM140.44,14.66c-1.13,1.22-1.7,2.89-1.7,5.01s.57,3.79,1.7,4.99c1.13,1.2,2.63,1.81,4.5,1.81s3.31-.62,4.48-1.85c1.18-1.23,1.76-2.88,1.76-4.95s-.59-3.76-1.76-4.99c-1.18-1.23-2.67-1.85-4.48-1.85s-3.37.61-4.5,1.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "0f2836",
      strokeWidth: 0
    },
    points: "186.08 7.9 179.49 7.9 173.54 23.88 167.12 7.9 160.45 7.9 170.35 30.77 165.86 40.84 172.43 40.84 186.08 7.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f2836",
      strokeWidth: 0
    },
    d: "M205.03,10.07c2.03,1.64,3.29,3.88,3.8,6.71h-6.33c-.26-1.25-.84-2.23-1.74-2.95-.91-.72-2.05-1.08-3.44-1.08-1.59,0-2.91.59-3.97,1.76-1.06,1.18-1.59,2.9-1.59,5.16s.53,3.99,1.59,5.16c1.06,1.18,2.39,1.76,3.97,1.76,1.39,0,2.54-.36,3.44-1.08.91-.72,1.49-1.71,1.74-2.95h6.33c-.51,2.83-1.78,5.07-3.8,6.71-2.03,1.64-4.55,2.47-7.59,2.47-2.29,0-4.33-.49-6.12-1.47-1.78-.98-3.17-2.37-4.16-4.19-.99-1.81-1.49-3.95-1.49-6.42s.5-4.61,1.49-6.44c.99-1.83,2.38-3.22,4.16-4.19,1.78-.96,3.82-1.45,6.12-1.45,3.03,0,5.56.82,7.59,2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f2836",
      strokeWidth: 0
    },
    d: "M227.4,9.01c1.42.93,2.42,2.2,3.02,3.78v-4.89h5.95v23.54h-5.95v-4.93c-.6,1.59-1.6,2.85-3.02,3.8-1.42.95-3.12,1.42-5.1,1.42s-3.77-.48-5.35-1.45c-1.59-.96-2.83-2.36-3.72-4.19-.89-1.83-1.34-3.97-1.34-6.44s.45-4.61,1.34-6.44c.89-1.83,2.13-3.22,3.72-4.19,1.59-.96,3.37-1.45,5.35-1.45s3.68.47,5.1,1.4ZM219.67,14.66c-1.13,1.22-1.7,2.89-1.7,5.01s.57,3.79,1.7,4.99c1.13,1.2,2.63,1.81,4.5,1.81s3.31-.62,4.48-1.85c1.18-1.23,1.76-2.88,1.76-4.95s-.59-3.76-1.76-4.99c-1.18-1.23-2.67-1.85-4.48-1.85s-3.37.61-4.5,1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f2836",
      strokeWidth: 0
    },
    d: "M245.78,0v31.45h-5.99V0h5.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f2836",
      strokeWidth: 0
    },
    d: "M255.18,0v31.45h-5.99V0h5.99Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "0f2836",
      strokeWidth: 0
    },
    cx: 39.27,
    cy: 10.4,
    r: 9.53
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "0f2836",
      strokeWidth: 0
    },
    cx: 69.02,
    cy: 10.4,
    r: 9.53
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "0f2836",
      strokeWidth: 0
    },
    cx: 9.53,
    cy: 40.15,
    r: 9.53
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "0f2836",
      strokeWidth: 0
    },
    cx: 9.53,
    cy: 69.9,
    r: 9.53
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "0f2836",
      strokeWidth: 0
    },
    cx: 39.27,
    cy: 69.9,
    r: 9.53
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "0f2836",
      strokeWidth: 0
    },
    cx: 69.02,
    cy: 40.15,
    r: 9.53
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f2836",
      strokeWidth: 0
    },
    d: "M48.8,30.62h0v19.05h-19.05c0-10.51,8.54-19.05,19.05-19.05Z",
    transform: "translate(79.42 .88) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0f2836",
      strokeWidth: 0
    },
    d: "M78.55,60.37h0v19.05h-19.05c0-10.51,8.54-19.05,19.05-19.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0f2836",
      strokeWidth: 0
    },
    y: 0.88,
    width: 19.05,
    height: 19.05
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.03701121f61fa662b935402504f916ec.svg";
export { ForwardRef as ReactComponent };